export default {
  name: "Name",
  tel: "Phone",
  save: "Save",
  confirm: "Confirm",
  cancel: "Cancel",
  delete: "Delete",
  loading: "Loading...",
  noCoupon: "No coupons",
  nameEmpty: "Please fill in the name",
  addContact: "Add contact",
  telInvalid: "Malformed phone number",
  vanCalendar: {
    end: "End",
    start: "Start",
    title: "Calendar",
    weekdays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    confirm: "confirm",
    startEnd: "Start End"
  },
  vanCascader: { select: "Select" },
  vanPagination: { prev: "Previous", next: "Next" },
  vanPullRefresh: {
    pulling: "Pull to refresh...",
    loosing: "Loose to refresh..."
  },
  vanSubmitBar: { label: "Total:" },
  vanCoupon: { unlimited: "Unlimited" },
  vanCouponCell: { title: "Coupon", tips: "not available" },
  vanCouponList: {
    exchange: "Exchange",
    close: "Close",
    enable: "Available",
    disabled: "Unavailable",
    placeholder: "Coupon code",
    empty: "No coupons"
  },
  vanAddressEdit: {
    area: "Area",
    postal: "Postal",
    areaEmpty: "Please select a receiving area",
    addressEmpty: "Address can not be empty",
    postalEmpty: "Wrong postal code",
    addressDetail: "Address",
    defaultAddress: "Set as the default address",
    telPlaceholder: "Consignee mobile number",
    namePlaceholder: "Name of the consignee",
    areaPlaceholder: "Select a province/city/district"
  },
  vanAddressList: { add: "Add new address" },
  complete: "Finish",
  telEmpty: "Please fill in your phone number",
  nameInvalid: "Please enter a valid name",
  confirmDelete: "Are you sure you want to delete it",
  vanContactCard: { addText: "Add a contact" },
  vanContactList: { addText: "New contact person" },
  vanAddressEditDetail: {
    label: "address",
    placeholder: "Street door number, floor room number and other information"
  }
};
